<script setup lang="ts">
  import type { TalkRoomUser } from "~/entities/TalkRoomUser";
  import { useTalkRoomStore } from "~/stores/TalkRoomStore";

  const talkRoomStore = useTalkRoomStore();

  defineEmits(["onUserClick"]);

  const modal = ref(false);
  const goodCount = ref(0);
  const localTalkId = ref("");
  const page = ref(1);
  const isLast = ref(false); // 最後までロードしたかどうか
  const users = ref<TalkRoomUser[]>([]);

  const openModal = (talkId: any, count: number) => {
    localTalkId.value = talkId;
    modal.value = true;
    goodCount.value = count;
    page.value = 1;
    isLast.value = false;
    users.value = [];
  };

  const load = async ({ done }: any) => {
    if (isLast.value) {
      done("empty");
      return;
    }
    const newUsers = await talkRoomStore.getGoodUsers(localTalkId.value, page.value);
    users.value = [...users.value, ...newUsers];
    if (newUsers.length === 100) {
      done("ok");
      page.value++;
    } else {
      isLast.value = true;
      done("empty");
    }
  };

  defineExpose({
    openModal,
  });

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
</script>

<template>
  <v-dialog v-model="modal" :max-width="450" scrim="black" scrollable>
    <v-card
      class="d-flex flex-column justify-center dialog-body"
      :class="[isSp ? 'py-4' : 'px-4 py-8']"
      data-testid="talk-like-dialog"
    >
      <div class="close-button" @click="modal = false">✕</div>
      <div class="dialog-title">リアクション</div>
      <div class="good-count" :class="[isSp ? 'mt-6' : 'mt-4']">合計{{ goodCount }}</div>

      <div class="user-list-wrapper">
        <v-infinite-scroll class="user-list" :height="300" @load="load">
          <div
            v-for="(user, index) in users"
            :key="index"
            class="user-list-item"
            :class="{ 'is-last': index === users.length - 1 }"
            @click="$emit('onUserClick', user)"
          >
            <v-avatar :size="30" class="mr-2">
              <v-img :src="user.iconPath" />
            </v-avatar>
            <div class="user-name">{{ user.userName }}</div>
          </div>
          <template #empty>
            <div class=""></div>
          </template>
        </v-infinite-scroll>
      </div>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .dialog-body {
    height: 100%;
    color: white;
    background-color: rgba(var(--v-theme-monochrome-04), 0.85);
  }
  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    color: white;
    padding: 10px 15px;
    cursor: pointer;
    z-index: 99;
  }
  .dialog-title {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    margin-top: 12px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
  }
  .good-count {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
  }
  .user-list-wrapper {
    border-top: 1px solid rgba(white, 0.1);
    margin: 20px 40px 0 40px;
  }
  .user-list {
    max-height: 300px;
    overflow-y: auto;
    // set scrollbar none
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .user-list-item {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    font-size: 14px;
    cursor: pointer;
    &.is-last {
      padding-bottom: 0;
    }
  }
</style>
